// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customHeight[data-v-7028d9a4]{\n  height: 34px !important;\n}\n.documentHeight[data-v-7028d9a4]{\n  height: 46px !important;\n}\n", ""]);
// Exports
module.exports = exports;
